import { render, staticRenderFns } from "./pdfViewer.vue?vue&type=template&id=2965faaf"
import script from "./pdfViewer.vue?vue&type=script&lang=ts"
export * from "./pdfViewer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports